"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const find_1 = __importDefault(require("lodash/find"));
const get_1 = __importDefault(require("lodash/get"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const keyBy_1 = __importDefault(require("lodash/keyBy"));
const keys_1 = __importDefault(require("lodash/keys"));
const map_1 = __importDefault(require("lodash/map"));
const size_1 = __importDefault(require("lodash/size"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const mobx_1 = require("mobx");
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
const filterFleet_1 = __importDefault(require("./utils/fleetFilter/filterFleet"));
const fleetFilter_store_1 = __importDefault(require("./fleetFilter.store"));
const fleetGroup_store_1 = __importDefault(require("./fleetGroup.store"));
const fleetPrice_store_1 = __importDefault(require("./fleetPrice.store"));
/**
 * Fleet Page Store
 * Consumes FleetGroup, FleetPrice & FleetFilter stores
 * Maintains Listing Page related data and state
 */
class FleetPageStore {
    constructor(initialState = {}, $env) {
        /**
         * Returns fleet (group + price) object for passed group id
         * @param {number} groupId
         * @returns {Object}
         */
        this.getFleetByGroupId = (groupId) => {
            return this.fleetGroupIdHashMap[groupId];
        };
        /**
         * Returns match fleet by passed groupId
         * @param {Array} fleets
         * @param {number} groupId
         * @returns {Object}
         */
        this.getFleetYearModelByGroupId = (fleets, groupId) => {
            const fleetGroupIdHashMap = (0, keyBy_1.default)(fleets, 'groupId');
            return fleetGroupIdHashMap[groupId];
        };
        /**
         * Returns fleet group by year model for passed fleet list
         * @param {Array} fleetList
         * @returns {Array}
         */
        this.getFleetsGroupedByModelYear = (fleetList) => {
            const list = fleetList;
            const formattedList = (0, map_1.default)(list, (item) => {
                const makeId = (0, get_1.default)(item, 'makeId', 0);
                const modelId = (0, get_1.default)(item, 'modelId', 0);
                return Object.assign(Object.assign({}, item), { fleetYearId: `${makeId}_${modelId}` });
            });
            const hashMapByFleetYearId = (0, groupBy_1.default)(formattedList, 'fleetYearId');
            const fleetYearKeys = (0, keys_1.default)(hashMapByFleetYearId);
            const formattedYearGroupList = (0, map_1.default)(fleetYearKeys, (key) => {
                const yearGroupFleet = hashMapByFleetYearId[key];
                const sortedYearGroupFleet = (0, sortBy_1.default)(yearGroupFleet, 'modelYear');
                const hasYearGroupFleet = yearGroupFleet && yearGroupFleet.length > 1;
                const fleet = (0, find_1.default)(formattedList, (fleetItem) => {
                    return fleetItem.fleetYearId === key;
                });
                if (hasYearGroupFleet) {
                    return Object.assign(Object.assign({}, fleet), { yearGroupFleet: sortedYearGroupFleet });
                }
                return fleet;
            });
            return formattedYearGroupList;
        };
        /** end-no-seo */
        /**
         * Initialize filters method
         * Should be called once filter is ready to be accessed
         * eg. when fleet group data is available
         */
        this.initializeFilters = () => {
            this.fleetFilter.initializeFilterState(this.availableFleet);
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
        // initialize domain stores
        this.fleetGroup = new fleetGroup_store_1.default(initialState.fleetGroup, $env);
        this.fleetPrice = new fleetPrice_store_1.default(initialState.fleetPrice, $env);
        this.fleetFilter = new fleetFilter_store_1.default(initialState.fleetFilter);
    }
    /**
     * Returns current config language
     * @returns {Boolean}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**  start-no-seo */
    /**
     * Returns true the loading status for price call
     * @returns {Boolean}
     */
    get isPriceLoading() {
        return this.fleetPrice.isLoading;
    }
    /** end-no-seo */
    /**
     * Returns true if price API fetch was success
     * @returns {Boolean}
     */
    get isPriceSuccess() {
        return this.fleetPrice.isSuccess;
    }
    /**  start-no-seo */
    /**
     * Returns true if price API fetch has failed
     * @returns {Boolean}
     */
    get hasPriceFailed() {
        return this.fleetPrice.hasFailed;
    }
    /**
     * Returns true if price API fetch returned no data
     * @returns {Boolean}
     */
    get hasPriceNoData() {
        return this.fleetPrice.hasNoData;
    }
    /**
     * Returns the no of fleet items.
     * @returns {number}
     */
    get count() {
        return (0, size_1.default)(this.fleet);
    }
    /** end-no-seo */
    /**
     * Returns the no of all filtered fleet items.
     * @returns {number}
     */
    get allfilteredCount() {
        return (0, size_1.default)(this.allfilteredFleet);
    }
    /**
     * Returns the no of filtered fleet items.
     * @returns {number}
     */
    get filteredCount() {
        return (0, size_1.default)(this.sortedFilteredFleet);
    }
    /**
     * Returns the final list of fleet group with price info
     * merged into one array of objects (mergin group + price) w.r.t groupIds
     * @returns {Array}
     */
    get fleet() {
        const priceList = (0, get_1.default)(this.fleetPrice, 'fleetPriceList', []);
        return (0, map_1.default)(priceList, (fleetPriceItem) => {
            const group = (0, get_1.default)(fleetPriceItem, 'group', {});
            return Object.assign(Object.assign({}, group), fleetPriceItem);
        });
    }
    /**
     * Returns only the list of fleets that are available
     * Uses the availablility flag from pricing api
     * Because right now fleet price API returns only available fleets
     * @returns {Array}
     */
    get availableFleet() {
        return (0, filter_1.default)(this.fleet, (fleet) => {
            return (0, get_1.default)(fleet, 'available', false);
        });
    }
    /**
     * Returns all filtered set of fleet data
     * This property should be used in FE
     * @returns {Array}
     */
    get allfilteredFleet() {
        return (0, filterFleet_1.default)(this.fleetFilter.filterCriteria, this.availableFleet);
    }
    /**
     * Returns filtered set of fleet data
     * This property should be used in FE
     * @returns {Array}
     */
    get filteredFleet() {
        return (0, filter_1.default)(this.allfilteredFleet, (fleet) => {
            return !(0, get_1.default)(fleet, 'promoted', true);
        });
    }
    /**
     * Returns true if fleets has promoted fleets
     * @returns {Boolean}
     */
    get hasPromotedFleet() {
        return !!(0, size_1.default)(this.promotedFilteredFleet);
    }
    /**
     * Returns promoted set of fleet data
     * This property should be used in FE
     * @returns {Array}
     */
    get promotedFilteredFleet() {
        return (0, filter_1.default)(this.sortedAllFilteredFleet, (fleet) => {
            return (0, get_1.default)(fleet, 'promoted', false);
        });
    }
    /**
     * Returns sorted filtered set of fleet data
     * This property should be used in FE
     * @returns {Array}
     */
    get sortedFilteredFleet() {
        return (0, sortBy_1.default)(this.filteredFleet, 'sortPrice');
    }
    /**
     * Returns sorted filtered set of fleet data
     * This property should be used in FE
     * @returns {Array}
     */
    get sortedAllFilteredFleet() {
        return (0, sortBy_1.default)(this.allfilteredFleet, 'sortPrice');
    }
    /**  start-no-seo */
    /**
     * Returns fleet hashmap by group id
     * @returns {Object}
     */
    get fleetGroupIdHashMap() {
        return (0, keyBy_1.default)(this.sortedAllFilteredFleet, 'groupId');
    }
}
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "isPriceLoading", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "isPriceSuccess", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "hasPriceFailed", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "hasPriceNoData", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "count", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "allfilteredCount", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "filteredCount", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "fleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "availableFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "allfilteredFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "filteredFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "hasPromotedFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "promotedFilteredFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "sortedFilteredFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "sortedAllFilteredFleet", null);
__decorate([
    mobx_1.computed
], FleetPageStore.prototype, "fleetGroupIdHashMap", null);
__decorate([
    mobx_1.action.bound
], FleetPageStore.prototype, "updateInitialState", void 0);
exports.default = FleetPageStore;
